import React, { useState, useEffect } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  Button,
  IconButton,
  InputLabel,
  FormControl,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';


const AddTaskPopup = ({ onClose }) => {
  const [taskName, setTaskName] = useState('');
  const [priority, setPriority] = useState('');
  const [clientName, setClientName] = useState('');
  const [TaskSubmissionDate, settasksubmissionDate] = useState('');
  const [startDate, setstartDate] = useState('');
  const [submission_date, setsubmission_date] = useState('');
  const [projectName, setProjectName] = useState('');
  const [mode, setMode] = useState('task'); // ⬅️ Internal state for switching
  const [users, setUsers] = useState([]);
  const [assignTo, setAssignTo] = useState('');
  const [client, setClient] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [category, setCategory] = useState('');
  const [submissionDate, setSubmissionDate] = useState('');
    const [assignBy, setAssignBy] = useState('');
    const [categories, setCategories] = useState([]);
    const [user, setUser] = useState(null);

    useEffect(() => {
        axios
          .get("/api/mainuser.php?action=dashboard", {
            withCredentials: true,
          })
          .then((res) => setUser(res.data.user))
          .catch(() => (window.location.href = "/userlogin"));
      }, []);
    
      useEffect(() => {
        axios.get('/api/categories.php')
          .then(res => setCategories(res.data))
          .catch(err => console.error(err));
      }, []);




  useEffect(() => {
    if (mode === 'task') {
      fetch('/api/projectoptions.php', {
        credentials: 'include',
      })
        .then((res) => res.json())
        .catch((err) => console.error('Failed to load projects', err));
    }
  }, [mode]);



  // Fetch users from your backend
  useEffect(() => {
    fetch('/api/useroptions.php', {
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error('Failed to load users', err));
  }, []);

  const handleSubmitTask = () => {
    const taskData = {
      task_name: taskName,
      assign_by: assignBy,
      client_name: clientName,
      due_date: TaskSubmissionDate,
      assign_to: assignTo,
      priority,
      submission_date,
      start_date: startDate
    };

  fetch('/api/useraddtask.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(taskData)
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === 'success') {
        alert('Task saved successfully');
        window.location.reload();
      } else {
        alert('Failed to save task');
      }
    })
    .catch((err) => {
      console.error('Error saving task:', err);
      alert('Error saving task');
    });
};

const handleSubmitProject = (e) => {
  e.preventDefault();

  const data = {
    name: projectName,
    client,
    company_name: companyName,
    category,
    assign_to: assignTo,
    assign_by: user?.name,
    submisssion_date: submissionDate
  };

  fetch('/api/userproject.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(data => {
      if (data.status === 'success') {
        alert('Project saved successfully');
        window.location.reload();
      } else {
        alert('Failed to save project');
      }
    })
    .catch(err => {
      console.error('Error saving project:', err);
      alert('Error saving project');
    });
};




  return (
    <div className="fixed inset-0 bg-gradient backdrop-blur-sm from-blue-10 to-black z-50 flex justify-center items-center">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-lg relative">
        <IconButton
          onClick={onClose}
          className="!absolute !top-2 !right-2 !text-gray-500 hover:!text-black"
        >
          <CloseIcon />
        </IconButton>

        <div className='flex'>
              <h2 className="text-xl font-bold mb-2">
                {mode === 'task' ? 'Add New Task' : 'Add New Project'}
              </h2>
        </div>
        <div className="flex gap-2 mb-5 ">
                <Button
                  variant={mode === 'task' ? 'contained' : 'outlined'}
                  size="small"
                  onClick={() => setMode('task')}
                  sx={{
                    px: 1,
                    py: 0.5,
                    border: 'none',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    backgroundColor: mode === 'task' ? 'rgb(43, 43, 44)' : 'transparent',
                    color: mode === 'task' ? 'white' : 'rgb(35, 38, 41)',
                    '&:hover': {
                      backgroundColor: mode === 'task' ? 'rgb(17, 18, 19)' : 'rgba(0, 0, 0, 0.77)',
                      color: mode === 'task' ? 'white' : 'rgb(249, 251, 253)',
                    },
                  }}
                >
                  Add Task
                </Button>
                <Button
                  variant={mode === 'project' ? 'contained' : 'outlined'}
                  size="small"
                  onClick={() => setMode('project')}
                  sx={{
                    px: 1,
                    py: 0.5,
                    border: 'none',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    backgroundColor: mode === 'project' ? 'rgb(43, 43, 44)' : 'transparent',
                    color: mode === 'project' ? 'white' : 'rgb(35, 38, 41)',
                    '&:hover': {
                      backgroundColor: mode === 'project' ? 'rgb(17, 18, 19)' : 'rgba(0, 0, 0, 0.77)',
                      color: mode === 'project' ? 'white' : 'rgb(249, 251, 253)',
                    },
                  }}
                >
                  Add Project
                </Button>
              </div>

        {mode === 'task' ? (
            <form className="space-y-4">
                <TextField
                  fullWidth
                  label="Task Name"
                  variant="outlined"
                  size="small"
                  value={taskName}
                  onChange={(e) => setTaskName(e.target.value)}
                />
                 <div className='flex gap-4 mt-4' >
                                  <TextField
                                  fullWidth
                                  label="Client Name"
                                  variant="outlined"
                                  size="small"
                                  value={clientName}
                                  onChange={(e) => setClientName(e.target.value)}
                                />
                
                                <TextField
                                          fullWidth
                                          label="Start Date"
                                          type="date"
                                          size="small"
                                          value={startDate}
                                          onChange={(e) => setstartDate(e.target.value)}
                                          InputLabelProps={{ shrink: true }}
                                />
                
                                </div>
               <div className="flex gap-4 mt-4">
                  <FormControl fullWidth size="small">
                    <InputLabel>Assign By</InputLabel>
                    <Select
                      value={assignBy}
                      label="Assign By"
                      onChange={(e) => setAssignBy(e.target.value)}
                    >
                      {users.map((user) => (
                        <MenuItem key={user.id} value={user.name}>
                          {user.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                    <FormControl fullWidth size="small">
                      <InputLabel>Assign To</InputLabel>
                      <Select
                        value={assignTo}
                        label="Assign To"
                        onChange={(e) => setAssignTo(e.target.value)}
                      >
                        {users.map((user) => (
                          <MenuItem key={user.id} value={user.name}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                        <InputLabel>Priority</InputLabel>
                        <Select
                          value={priority}
                          label="Priority"
                          onChange={(e) => setPriority(e.target.value)}
                        >
                          <MenuItem value="Medium">Medium</MenuItem>
                          <MenuItem value="Urgent">Urgent</MenuItem>
                        </Select>
                      </FormControl>
                  </div>

                  <div className="flex gap-4 mt-6">
                      <TextField
                        fullWidth
                        label="Tentative Time"
                        type="number"
                        size="small"
                        value={submission_date}
                        onChange={(e) => setsubmission_date(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
      
                        <TextField
                          fullWidth
                          label="Submission Date"
                          type="date"
                          size="small"
                          value={TaskSubmissionDate}
                          onChange={(e) => settasksubmissionDate(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <Button
                      variant="contained"
                      type="button"
                      className="!mt-2"
                      sx={{ background: '#374151' }}
                      onClick={handleSubmitTask}
                    >
                      Save Task
                    </Button>
          </form>
        ) : (
          <form className="space-y-4" onSubmit={handleSubmitProject}>
                <TextField
                  fullWidth
                  label="Project Name"
                  variant="outlined"
                  size="small"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                />
                <div className="flex gap-4 mt-6">
                  <div className="w-1/2">
                        <TextField
                          fullWidth
                          label="Client"
                          variant="outlined"
                          size="small"
                          value={client}
                          onChange={(e) => setClient(e.target.value)}
                        />
                        </div>

                        <div className="w-1/2">
                        <FormControl fullWidth size="small">
                          <InputLabel>Manage By</InputLabel>
                          <Select
                            value={assignTo}
                            label="Manage By"
                            onChange={(e) => setAssignTo(e.target.value)}
                          >
                            {users.map((user) => (
                              <MenuItem key={user.id} value={user.name}>
                                {user.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                    </div>
                    
                </div>
                <div className="flex gap-4 mt-6">
                    <div className="w-1/2">
                        <FormControl fullWidth variant="outlined" size="small">
  <InputLabel id="category-label">Category</InputLabel>
  <Select
    labelId="category-label"
    id="category"
    value={category}
    label="Category"
    onChange={(e) => setCategory(e.target.value)}
  >
    {categories.map((cat) => (
      <MenuItem key={cat.id} value={cat.category_name}>
        {cat.category_name}
      </MenuItem>
    ))}
  </Select>
</FormControl>

                    </div>
                    <div className="w-1/2">
                        <FormControl fullWidth size="small">
                          <InputLabel>Company Name</InputLabel>
                          <Select
                            value={companyName}
                            label="Company Name"
                            onChange={(e) => setCompanyName(e.target.value)}
                          >
                            <MenuItem value="Leela Greens">Leela Greens</MenuItem>
                            <MenuItem value="Academic Guru">Academic Guru</MenuItem>
                            <MenuItem value="IJISEM">IJISEM</MenuItem>
                            <MenuItem value="AGPH">AGPH</MenuItem>
                          </Select>
                        </FormControl>
                    </div>
                    
                    
                </div>
                <div className="flex gap-4 mt-6">
                    
                  
                    <div className="w-1/2">
                        <TextField
                          fullWidth
                          label="Deadline"
                          type="date"
                          size="small"
                          InputLabelProps={{ shrink: true }}
                          value={submissionDate}
                          onChange={(e) => setSubmissionDate(e.target.value)}
                        />
                    </div>
                </div>
              <Button variant="contained" type="submit" className="!mt-2" sx={{ background: '#374151' }}>
                Save Project
              </Button>
          </form>

        )}
      </div>
    </div>
  );
};

export default AddTaskPopup;
